import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "me-icon-close_other",
  "use": "me-icon-close_other-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"me-icon-close_other\"><defs><style type=\"text/css\"></style></defs><path d=\"M764.8 112v800h-512v-800h512z m-96 96h-320v608h320v-608zM928 256v512h-96V256h96zM192 256v512H96V256h96z m252.8 124.8L512 448l67.2-67.2 67.2 67.2-67.2 67.2 67.2 67.2-67.2 67.2-67.2-64-67.2 67.2-67.2-67.2 67.2-67.2-70.4-70.4 70.4-67.2z\" p-id=\"29956\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol